import React from 'react'
import CreateVirtualCard from 'src/app/CreateVirtualCard/CreateVirtualCard'
import { AppRoute } from 'src/navigation/appRoutes'
import { createVirtualCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CreateVirtualCardAppRoute: AppRoute = {
  id: AppLocation.CreateVirtualCard,
  routeProps: createVirtualCardRouteProps,
  component: <CreateVirtualCard />,
  subRoutes: [],
}

export default CreateVirtualCardAppRoute
